/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../component/card_accessory';
import '../component/component';
import '../component/card_customization';
import '../../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "debit_card": {
                "nested": {
                  "DebitCard": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "cardInvite": {
                        "type": ".squareup.bbfrontend.common.debit_card.DebitCard.PendingCard",
                        "id": 1
                      },
                      "orderedCard": {
                        "type": ".squareup.bbfrontend.common.debit_card.DebitCard.OrderedCard",
                        "id": 2
                      }
                    },
                    "nested": {
                      "PendingCard": {
                        "fields": {
                          "inviteToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cardName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "secondaryText": {
                            "type": ".squareup.bbfrontend.common.debit_card.SecondaryText",
                            "id": 4,
                            "rule": "optional"
                          },
                          "cardListElement": {
                            "type": ".squareup.bbfrontend.common.debit_card.CardRenderingDescription",
                            "id": 5,
                            "rule": "optional"
                          },
                          "cardLeadingAccessory": {
                            "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription",
                            "id": 6,
                            "rule": "optional"
                          },
                          "titleTrailingAccessory": {
                            "type": ".squareup.bbfrontend.common.debit_card.TitleTrailingAccessory",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "OrderedCard": {
                        "fields": {
                          "cardToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cardName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "isActivatable": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "isLocked": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          },
                          "secondaryText": {
                            "type": ".squareup.bbfrontend.common.debit_card.SecondaryText",
                            "id": 6,
                            "rule": "optional"
                          },
                          "cardListElement": {
                            "type": ".squareup.bbfrontend.common.debit_card.CardRenderingDescription",
                            "id": 7,
                            "rule": "optional"
                          },
                          "isClosed": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "cardLeadingAccessory": {
                            "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription",
                            "id": 9,
                            "rule": "optional"
                          },
                          "titleTrailingAccessory": {
                            "type": ".squareup.bbfrontend.common.debit_card.TitleTrailingAccessory",
                            "id": 10,
                            "rule": "optional"
                          },
                          "cardReplacement": {
                            "type": ".squareup.bbfrontend.common.debit_card.CardReplacement",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      },
                      "data": {
                        "oneof": ["cardInvite", "orderedCard"]
                      }
                    }
                  },
                  "TitleTrailingAccessory": {
                    "fields": {
                      "pill": {
                        "type": ".squareup.bbfrontend.common.component.PillDescription",
                        "id": 1
                      }
                    },
                    "nested": {
                      "accessory": {
                        "oneof": ["pill"]
                      }
                    }
                  },
                  "SecondaryText": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "textStyle": {
                        "type": ".squareup.bbfrontend.common.debit_card.SecondaryText.SecondaryTextStyle",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "STANDARD"
                        }
                      }
                    },
                    "nested": {
                      "SecondaryTextStyle": {
                        "values": {
                          "STANDARD": 1,
                          "ACTION": 2
                        }
                      }
                    }
                  },
                  "CardRenderingDescription": {
                    "fields": {
                      "businessName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "bodyVariation": {
                        "type": ".squareup.bbfrontend.common.debit_card.CardRenderingDescription.BodyVariation",
                        "id": 4,
                        "rule": "optional"
                      },
                      "cardCustomization": {
                        "type": ".squareup.bbfrontend.common.component.CardCustomization",
                        "id": 2
                      },
                      "asyncCardCustomization": {
                        "type": ".squareup.bbfrontend.common.component.AsyncCardCustomization",
                        "id": 3
                      }
                    },
                    "nested": {
                      "BodyVariation": {
                        "values": {
                          "DO_NOT_USE_BODY_VARIATION": 0,
                          "BODY_VARIATION_US": 1,
                          "BODY_VARIATION_CA": 2,
                          "BODY_VARIATION_UK": 3,
                          "BODY_VARIATION_DIGITAL_US": 4
                        }
                      },
                      "customization": {
                        "oneof": ["cardCustomization", "asyncCardCustomization"]
                      }
                    }
                  },
                  "CardReplacement": {
                    "fields": {
                      "replacementDueDate": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 11,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.DebitCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.DebitCard?.nested?.PendingCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.DebitCard?.nested?.OrderedCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.TitleTrailingAccessory && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.SecondaryText && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.SecondaryText?.nested?.SecondaryTextStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.CardRenderingDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.CardRenderingDescription?.nested?.BodyVariation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.debit_card?.nested?.CardReplacement) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DebitCard @ squareup/bbfrontend/common/debit_card/debit_card.proto at 14:1
 */
export const DebitCard = $root.lookupType('squareup.bbfrontend.common.debit_card.DebitCard');
fixType(DebitCard, {
  unitToken: {
    required: true
  }
});
Builder.createAndAttachToType(DebitCard);
/**
 * This is a card that's not claimed yet, but an invite has been sent.
 *
 * SOURCE PendingCard @ squareup/bbfrontend/common/debit_card/debit_card.proto at 26:3
 */
DebitCard.PendingCard = $root.lookupType('squareup.bbfrontend.common.debit_card.DebitCard.PendingCard');
fixType(DebitCard.PendingCard, {
  inviteToken: {
    notEmpty: true
  },
  cardName: {
    notEmpty: true
  },
  cardListElement: {
    required: true
  },
  cardLeadingAccessory: {
    required: true
  }
});
Builder.createAndAttachToType(DebitCard.PendingCard);
/**
 * This is a claimed
 *
 * SOURCE OrderedCard @ squareup/bbfrontend/common/debit_card/debit_card.proto at 45:3
 */
DebitCard.OrderedCard = $root.lookupType('squareup.bbfrontend.common.debit_card.DebitCard.OrderedCard');
fixType(DebitCard.OrderedCard, {
  cardToken: {
    notEmpty: true
  },
  cardName: {
    notEmpty: true
  },
  isActivatable: {
    required: true
  },
  isLocked: {
    required: true
  },
  secondaryText: {
    required: true
  },
  cardListElement: {
    required: true
  },
  isClosed: {
    required: true
  },
  cardLeadingAccessory: {
    required: true
  }
});
Builder.createAndAttachToType(DebitCard.OrderedCard);
/**
 * SOURCE TitleTrailingAccessory @ squareup/bbfrontend/common/debit_card/debit_card.proto at 70:1
 */
export const TitleTrailingAccessory = $root.lookupType('squareup.bbfrontend.common.debit_card.TitleTrailingAccessory');
fixType(TitleTrailingAccessory);
Builder.createAndAttachToType(TitleTrailingAccessory);
/**
 * SOURCE SecondaryText @ squareup/bbfrontend/common/debit_card/debit_card.proto at 76:1
 */
export const SecondaryText = $root.lookupType('squareup.bbfrontend.common.debit_card.SecondaryText');
fixType(SecondaryText, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SecondaryText);
/**
 * Per designs, we have different types of text decorators - standard and action.
 * We want the server to pass down what type of treatment the secondary line should get.
 *
 * SOURCE SecondaryTextStyle @ squareup/bbfrontend/common/debit_card/debit_card.proto at 84:3
 */
SecondaryText.SecondaryTextStyle = $root.lookupEnum('squareup.bbfrontend.common.debit_card.SecondaryText.SecondaryTextStyle').values;
/**
 * Note: This is deprecated in favor of CardAccessoryDescription. It is populated for legacy clients.
 * On the card list row we draw a small version of a UiElements.CardElement, there isn't
 * much customization to that, so this is a very simple card element just for business_name + signature.
 *
 * SOURCE CardRenderingDescription @ squareup/bbfrontend/common/debit_card/debit_card.proto at 95:1
 */
export const CardRenderingDescription = $root.lookupType('squareup.bbfrontend.common.debit_card.CardRenderingDescription');
fixType(CardRenderingDescription, {
  bodyVariation: {
    required: true
  }
});
Builder.createAndAttachToType(CardRenderingDescription);
/**
 * Represents a specific card body to render.
 * Currently this corresponds to the corresponding country, but there could be different variations in the future.
 *
 * SOURCE BodyVariation @ squareup/bbfrontend/common/debit_card/debit_card.proto at 112:3
 */
CardRenderingDescription.BodyVariation = $root.lookupEnum('squareup.bbfrontend.common.debit_card.CardRenderingDescription.BodyVariation').values;
/**
 * SOURCE CardReplacement @ squareup/bbfrontend/common/debit_card/debit_card.proto at 121:1
 */
export const CardReplacement = $root.lookupType('squareup.bbfrontend.common.debit_card.CardReplacement');
fixType(CardReplacement);
Builder.createAndAttachToType(CardReplacement);